const profileES = {
    "edit": {
        "title": "Edita tu perfil",
        "form": {
            "label": {
                "profileImage": "Imagen de perfil",
                "streetAndNumber": "Mi calle y número de casa",
                "postalCode": "Código postal",
                "city": "Ciudad",
                "country": "País",
                "vatNumber": "Número de IVA",
                "nationalTaxNumber": "Número de Impuesto Nacional",
                "businessRegistrationNumber": "Número de Registro Comercial",
                "vatStatus": "Estado del IVA",
                "businessType": "Tipo de negocio",
                "vatExemptDocument": "Documento de Exención de IVA",
                "businessCertificate": "Certificado de Negocio",
                "preferredPaymentMethod": "Método de pago preferido",
                "paypalEmail": "Correo electrónico de Paypal",
                "accountHolderName": "Nombre del titular de la cuenta bancaria",
                "bankName": "Nombre del banco",
                "bankAddress": "Dirección del banco",
                "iban": "IBAN"
            },
            "option": {
                "preferedMethod": {
                    "paypal": "Paypal",
                    "bankAccount": "Cuenta bancaria"
                }
            },
            "help_text": {
                "profileImage": "Sube formatos JPG, resolución solo 300x300 px, tamaño máximo 300 KB.",
                "iban": "Recuerda el prefijo de tu país, por ejemplo DE, FR, ES"
            },
            "button": {
                "submit": "Enviar"
            }
        },
        "message": {
            "success": "¡Tu perfil ha sido actualizado!",
            "error": "¡Algo salió mal! ¡Por favor, actualiza la página e inténtalo de nuevo!"
        },
        "modal": {
            "header": "¿Estás seguro de que deseas cambiar tu perfil?",
            "body": "Por la presente garantizas que todos los datos proporcionados son veraces. Eres el único y legalmente responsable de los datos proporcionados y de la veracidad de dicha información.",
            "button": {
                "cancel": "Cancelar",
                "confirm": "Confirmar"
            }
        }
    },
    "set_new_password": {
        "title": "Establecer nueva contraseña",
        "form": {
            "label": {
                "currentPassword": "Contraseña actual",
                "newPassword": "Nueva contraseña",
                "repeatNewPassword": "Repetir nueva contraseña"
            },
            "button": {
                "submit": "Enviar"
            },
            "validation": {
                "oldPasswordRequired": "Se requiere tu contraseña antigua",
                "newPasswordMin": "Tu contraseña debe tener una longitud mínima de 10 caracteres",
                "newPasswordRequired": "Se requiere nueva contraseña",
                "passwordsMustMatch": "La nueva contraseña debe coincidir"
            }
        },
        "message": {
            "success": "¡Tu contraseña ha sido cambiada!",
            "error": "¡Algo salió mal! ¡Por favor, actualiza la página e inténtalo de nuevo!"
        },
        "modal": {
            "header": "¿Estás seguro de que deseas cambiar tu contraseña?",
            "body": "Por favor confirma"
        }
    },
    "panel": {
        "label": {
            "emailAddress": "Dirección de correo electrónico",
            "paypalEmailAddress": "Dirección de correo electrónico de Paypal",
            "phone": "Teléfono",
            "streetAndHouseNumber": "Calle y número de casa",
            "postalCode": "Código postal",
            "city": "Ciudad",
            "country": "País",
            "paymentMethod": "Método de pago",
            "accountNumberHolder": "Titular del número de cuenta",
            "bankName": "Nombre del banco",
            "iban": "IBAN",
            "bic": "BIC",
            "bankAddress": "Dirección del banco",
            "paypal": "Paypal",
            "bankAccount": "Cuenta bancaria"
        }
    },
    "payment_method": {
        "title": "Método de pago",
        "label": {
            "card_number": "Número de tarjeta",
            "card_expiry": "Vencimiento",
            "default_method": "Predeterminado",
            "manage_method": "Gestionar",
            "add_method": "Agregar"
        }
    },
    "withholding_tax": {
        "title": "Impuesto de retención",
        "form": {
            "label": {
                "taxPercentage": "Porcentaje de impuesto",
                "whtStatus": "Estado WHT",
                "whtLicense": "Licencia WHT"
            },
            "help_text": {
                "uploadDocument": "Por favor, sube tu documento de impuesto de retención."
            },
            "button": {
                "submit": "Enviar",
                "removeFile": "¿Eliminar?"
            },
            "message": {
                "whtStatusText": "Según el Artículo 31 de la Ley del Impuesto sobre la Renta de Croacia, se aplica un impuesto de retención del 15-25% a los no residentes. Sin embargo, si resides en un país que tiene un Acuerdo para Evitar la Doble Imposición con Croacia, puedes calificar para una tasa de impuesto reducida. Puedes verificar si tu país está en la lista en <1><strong>este enlace</strong></1>.",
                "whtApplyRateText": "Para solicitar la tasa reducida, por favor haz clic en <1><strong>este documento</strong></1>. Descarga, completa y envía el formulario para beneficiarte de la tasa especificada en el acuerdo si eres elegible."
            }
        },
        "message": {
            "success": "Licencia WHT enviada con éxito. Será procesada por nuestro equipo.",
            "error": "Ocurrió un error al actualizar. Por favor, inténtalo de nuevo."
        }
    }
};

export default profileES;